import commercialCleaningKitchenLady from "../../assets/images/commercial-cleaning-kitchen-lady.jpg";
import floorCleanerGuyRidingMachine from "../../assets/images/floor-cleaner-guy-riding-machine.jpg";
import industrialCleaningPipeGuys from "../../assets/images/industrial-cleaning-pipe-guys.jpg";
import janitorialCleanerMop from "../../assets/images/janitorial-cleaner-mop.jpg";
import officeCleanerBlackWoman from "../../assets/images/office-cleaner-black-woman.png";
import windowCleaner from "../../assets/images/window-cleaner.jpg";

const galleryImages = [
  {
    src: officeCleanerBlackWoman,
    alt: "Office cleaner",
  },
  {
    src: industrialCleaningPipeGuys,
    alt: "Industrial cleaning",
  },
  {
    src: windowCleaner,
    alt: "Window cleaner",
  },
  {
    src: floorCleanerGuyRidingMachine,
    alt: "Floor cleaner",
  },
  {
    src: janitorialCleanerMop,
    alt: "Janitorial cleaner",
  },
  {
    src: commercialCleaningKitchenLady,
    alt: "Commercial cleaning",
  },
];

const AuthSideContent = ({ title, features, testimonial }) => {
  return (
    <div className="flex h-full flex-col justify-start">
      <div>
        <h2 className="mb-6 text-[2rem] font-bold leading-tight lg:whitespace-nowrap xl:text-[2.2rem]">
          {title}
        </h2>
        <ul className="space-y-5 pl-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start gap-4">
              <div className="mt-0.5 rounded-full bg-white/20 p-1">
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="max-w-xl text-base leading-7">{feature}</span>
            </li>
          ))}
        </ul>

        {/* Commercial cleaning operators image grid */}
        <div className="mt-24">
          <h3 className="mb-26 pl-2 text-lg font-medium">
            Trusted by commercial cleaning operators across the U.S.
          </h3>
          <div className="grid grid-cols-3 gap-4">
            {galleryImages.map((image) => (
              <div
                key={image.alt}
                className="aspect-square overflow-hidden rounded-md border-2 border-white bg-white/10 p-1 w-85 h-stretch85"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="h-full w-full rounded object-cover"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {testimonial && (
        <div className="mt-10">
          <div className="p-6 bg-white/10 rounded-lg">
            <p className="italic mb-16">{testimonial.quote}</p>
            <div className="flex items-center">
              <div>
                <p className="font-medium">{testimonial.name}</p>
                <p className="text-sm opacity-80">{testimonial.role}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthSideContent;
